import React from 'react';

import { Table } from 'components/MRT';

import { impactCostsTableColumns } from './impactCostsTableColumns';
import { CostsTableData } from '../../types';

export function ImpactCostsTable({ data }: { data: CostsTableData[] }) {
  const allCostsEmpty = data.every(
    ({ dumpCost, pumpCost }) =>
      dumpCost.fold(
        c => c.isZero(),
        () => true,
      ) &&
      pumpCost.fold(
        c => c.isZero(),
        () => true,
      ),
  );

  const pageSize = 5;
  const displaysFiltersAndPagination = data.length > pageSize;

  if (allCostsEmpty) {
    return null;
  }

  return (
    <Table<CostsTableData>
      initialState={{
        density: 'compact',
        columnOrder: [
          'asset',
          'marketPrice',
          'oraclePrice',
          'targetPumpPrice',
          'pumpCost',
          'targetDumpPrice',
          'dumpCost',
        ],
        pagination: {
          pageIndex: 0,
          pageSize,
        },
      }}
      autoPinningColumns={['asset']}
      data={data}
      columns={impactCostsTableColumns}
      enableTopToolbar={false}
      enableBottomToolbar={displaysFiltersAndPagination}
      enablePagination={displaysFiltersAndPagination}
      enableColumnFilterModes
      enableFilters={displaysFiltersAndPagination}
      enablePinning={false}
      enableToolbarInternalActions={false}
    />
  );
}
